function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 78.5,
  cy: 78.5,
  r: 78.5,
  fill: "#F4F4F4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 77.4531,
  y: 11,
  width: 1.8314,
  height: 68.8081,
  fill: "#6D6D6D"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 101,
  y: 20.1572,
  width: 1.8314,
  height: 45,
  transform: "rotate(90 101 20.1572)",
  fill: "#6D6D6D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.9238 19.8955H96.8134V67.2211L78.3686 59.9259L59.9238 67.2211V19.8955Z",
  fill: "#AAAAAA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M86.8719 35.8624V32.4238H78.5341V35.8176H79.8349L77.26 38.6191H76.1937V35.8176H77.6598V32.4238H75.6819V33.6977H74.6104V32.4238H72.6539V33.6977H71.5823V32.4238H69.6045V35.8624H71.3531V40.1419V44.4213H69.6045V47.8599H77.6598V44.4661H76.1937V41.6646H77.26L79.8349 44.4661H78.5341V47.8599H86.8719V44.4213H85.5765L81.6475 40.1419L85.5765 35.8624H86.8719Z",
  fill: "#0A0806"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 59.9238,
  y1: 23.3193,
  x2: 96.8134,
  y2: 23.3193,
  stroke: "#818181"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 92,
  width: 56,
  height: 54,
  fill: "#C4C4C4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M50 90H106V95.5882L50 109V90Z",
  fill: "#AAAAAA"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M73 132C73 129.239 75.2386 127 78 127C80.7614 127 83 129.239 83 132V146H73V132Z",
  fill: "#6D6D6D"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M98.68 74H89V80H83.72V74H74.04V80H68.76V74H59.08V80H53.8V74H45V90H111V74H103.96V80H98.68V74Z",
  fill: "#C4C4C4"
});

const SvgKeepTower = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeepTower, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keep-tower.d5eb0728.svg";
export { ForwardRef as ReactComponent };